<mat-card class="card-style modal-card px-6 py-6 pt-0">
  <mat-card-header class="modal-header flex justify-between items-center">
    <mat-card-title class="">Detalhes da ida ao Compras</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-6">
    <mat-card class="card-style info-card px-4 py-6">
      <h4 class="block-title mb-1">Proposta</h4>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-2/12"><strong>Tg:</strong> {{ item.codigoTg ?? '-' }}</div>
        <div class="w-7/12">
          <strong>Evento:</strong> {{ item.nomeEvento ?? '-' }}
        </div>
        <div class="w-3/12">
          <strong>Data da proposta:</strong> {{ item.dataProposta ?? '-' }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-8/12">
          <strong
            >{{
              item.nomeSubCliente && item.nomeSubCliente != ''
                ? 'Subcliente'
                : 'Cliente'
            }}:</strong
          >
          {{
            item.nomeSubCliente && item.nomeSubCliente != ''
              ? item.nomeSubCliente
              : (item.nomeCliente ?? '-')
          }}
        </div>
        <div class="w-4/12">
          <strong>Consultor:</strong> {{ item.nomeConsultor ?? '-' }}
        </div>
      </div>
    </mat-card>

    <mat-card class="card-style info-card px-4 py-6 mt-4">
      <h4 class="block-title mb-1">Item</h4>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-6/12">
          <strong>Origem:</strong> {{ item.origem ?? '-' }}
        </div>
        <div class="w-6/12">
          <strong>Destino:</strong> {{ item.destino ?? '-' }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-3/12">
          <strong>Tipo Serviço:</strong> {{ item.descricaoTipoServico ?? '-' }}
        </div>
        <div class="w-3/12">
          <strong>Serviço:</strong> {{ item.descricaoServico ?? '-' }}
        </div>
        <div class="w-3/12">
          <strong>Tipo Veículo:</strong> {{ item.descricaoTipoVeiculo ?? '-' }}
        </div>
        <div class="w-3/12">
          <strong>Tipo Motorista:</strong>
          {{ item.descricaoTipoMotorista ?? '-' }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-4/12"><strong>Pax:</strong> {{ item.pax ?? '-' }}</div>
        <div class="w-4/12">
          <strong>Data do serviço:</strong> {{ item.dataInicio ?? '-' }}
        </div>
        <div class="w-4/12">
          <strong>Hora do serviço:</strong> {{ item.horaInicio ?? '-' }}
        </div>
      </div>
    </mat-card>

    <mat-card
      class="card-style info-card round-card px-4 py-6 mt-4"
      [class.round-open]="emAberto"
    >
      <h4 class="block-title mb-1">Ida ao Compras</h4>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-4/12"><strong>Tipo:</strong> {{ item.tipo ?? '-' }}</div>
        <div class="w-8/12">
          <strong>Desfecho:</strong> {{ item.desfecho ?? '-' }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-6/12">
          <strong>Enviado em:</strong> {{ item.dataEnvio ?? '-' }}
          {{ item.horaEnvio ?? '' }}<br />
          <strong>Enviado por:</strong> {{ item.enviadoPor ?? '-' }}
        </div>
        <div class="w-6/12">
          <strong>Retornado em:</strong>
          {{ item.dataRetorno ? item.dataRetorno + ' ' + (item.horaRetorno ?? '') : '—' }}<br />
          <strong>Retornado por:</strong> {{ item.retornadoPor ?? '—' }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-full">
          <strong>Tempo útil</strong> (seg. a sex., 09:00 às 18:00):<br />
          <span class="tempo-util">{{ item.tempoUtil ?? '-' }}</span>
          @if (emAberto) {
            <span class="text-sm text-gray-600"> — em curso</span>
          }
        </div>
      </div>
    </mat-card>
  </div>
</mat-card>
